<template>
  <div class="row" v-if="canAccess">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <div class="row">
                <div class="col-md-2">
                  <div><label>ชื่อผู้ใช้</label></div>
                  <a-input
                    v-model:value="user"
                    placeholder="ชื่อผู้ใช้"
                    v-on:keyup.enter="searchUsers()"
                    allow-clear
                  />
                </div>
                <div class="col-md-2">
                  <div><label>บทบาท</label></div>
                  <a-select
                    mode="multiple"
                    v-model:value="selects.role"
                    style="width: 100%"
                    placeholder="เลือกบทบาท"
                    :options="selects.roles"
                  />
                </div>
                <div class="col-md-2">
                  <div><label style="color: transparent">ค้นหา</label></div>
                  <a-button type="primary" @click="searchUsers()">
                    ค้นหา
                  </a-button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <a-table
                    :columns="columns"
                    :data-source="data"
                    :loading="userLoaded"
                  >
                    <template #name="{ record }">
                      {{ record.name }} {{ record.surname }}
                    </template>
                    <template #status="{ record }">
                      {{
                        record.isActived === null
                          ? "รอยืนยัน"
                          : record.isActived
                          ? "เปิดใช้งาน"
                          : "ปิดการใช้งาน"
                      }}
                    </template>
                    <template #action="{ record }">
                      <router-link v-bind:to="'/user/' + record.uid">
                        รายละเอียด
                      </router-link>
                    </template>
                  </a-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-if="canAccess === false">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <a-result
            status="403"
            title="403"
            sub-title="ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้"
          >
            <template #extra>
              <a-button type="primary" @click="goToHome">กลับหน้าหลัก</a-button>
            </template>
          </a-result>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import moment from "moment";
import * as configuration from "../../../middleware/configuration";
import * as userservice from "../../../services/user";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "No",
    dataIndex: "no",
    key: "no",
  },
  {
    title: "อีเมล",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "ชื่อ",
    slots: { customRender: "name" },
    key: "name",
  },
  {
    title: "คะแนนสะสม",
    dataIndex: "reward",
    key: "reward",
  },
  {
    title: "วันที่สมัคร",
    dataIndex: "createdDateStr",
    key: "createdDate",
  },
  {
    title: "สถานะ",
    slots: { customRender: "status" },
    key: "isActived",
  },
  {
    title: "ประเภทบัญชี",
    dataIndex: "providers",
    key: "providers",
  },
  {
    title: "บทบาท",
    dataIndex: "roleName",
    key: "roleName",
  },
  {
    title: "Action",
    key: "id",
    align: "center",
    slots: { customRender: "action" },
  },
];
export default {
  methods: {
    async getRoles() {
      try {
        let res = await userservice.getRoles();
        res.data.map((m) => {
          this.selects.roles.push({ value: m.id, label: m.name });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.selects.rolesLoaded = true;
      }
    },
    async searchUsers() {
      this.userLoaded = true;
      let data = {
        name: this.user,
        roles: this.selects.role,
      };

      try {
        let res = await userservice.searchUser(data);
        let count = 1;
        res.data.map((x) => {
          x.no = count++;
          x.createdDateStr = this.getDate(x.createdDate);
        });
        this.data = res.data;
      } catch (error) {
        message.error("ไม่สามรถค้นหาได้ กรุณาลองอีกครั้ง");
        console.log(error);
      } finally {
        this.userLoaded = false;
      }
    },
    getDate(value) {
      if (value) return moment(value).format("DD/MM/YYYY hh:mm:ss");
      return "";
    },
    goToHome() {
      this.$router.push("/game");
    },
  },
  data() {
    return {
      columns: columns,
      userLoaded: false,
      data: [],
      user: "",
      canAccess: null,
      selects: {
        role: [],
        rolesLoaded: false,
        roles: [],
      },
    };
  },
  async beforeMount() {
    this.uid = await configuration.getUid();
    let result = await configuration.getIdTokenResult();
    if (result) {
      this.role = result.claims?.role || this.role;
      if (
        this.role === "admin" ||
        this.role === "manager" ||
        this.role === "staff"
      ) {
        this.searchUsers();
        this.getRoles();
        this.canAccess = true;
      } else {
        this.canAccess = false;
      }
    } else {
      this.canAccess = false;
    }
  },
};
</script>

<style>
</style>